<template>
  <div class="solvents">
    <div
      class="card"
      v-for="data in datas"
      :key="data.title"
      @mouseenter="mouseover(data.imgSrcDetail)"
    >
      <div class="info">
        <p class="title">
          <span class="text-title">{{ data.title }}</span>
        </p>
        <p class="intro">{{ data.intro }}</p>
        <!-- <div class="btn">Detailed</div> -->
      </div>
    </div>
    <el-drawer
      title="我是标题"
      :visible="visible"
      :with-header="false"
      @close="closed"
      size="60%"
    >
      <MelamineDetail />
    </el-drawer>
  </div>
</template>

<script>
import MLdetail from "./imgs/MLdetail.png";
import { debounce } from "lodash";
import MelamineDetail from "./MelamineDetail.vue";
export default {
  name: "Solvents",
  components: {
    MelamineDetail,
  },
  data() {
    return {
      visible: false,
      currentSrcStr: "MLdetail",
      imgDetails: {
        MLdetail,
      },
      datas: [
        {
          title: "Melamine(ML)",
          intro: "CAS No.: 108-78-1 MF: C3N6H6 EINECS No.: 203-615-4",
          imgSrcDetail: "MLdetail",
        },
      ],
    };
  },
  methods: {
    showDetailed(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    mouseover(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    closed() {
      this.visible = false;
    },
  },
  mounted() {
    this.mouseover = debounce(this.mouseover, 700);
  },
};
</script>

<style lang="less" scoped>
.solvents {
  .card {
    display: flex;
    background-color: #fff;
    margin-bottom: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    border-radius: 10px;
    // .img {
    //   display: block;
    //   position: relative;
    //   z-index: 2;
    //   width: 260px;
    //   border-right: solid 1px #ddd;
    // }
    .title {
      padding-left: 30px;
      line-height: 60px;
    }
    .text-title {
      font-size: 26px;
      color: #333;
    }
    &:hover {
      .text-title {
        animation: text-title 1s linear;
        animation-name: text-title;
        animation-delay: 0s;
        animation-timing-function: linear;
        animation-duration: 0.7s;
      }
    }
    @keyframes text-title {
      0% {
        margin-left: 0;
      }
      50% {
        margin-left: 50px;
        color: rgba(8, 84, 132, 1);
      }
      100% {
        margin-left: 0;
      }
    }
    .info {
      height: 150px;
      position: relative;
      z-index: 1;
      width: 100%;
      &:hover {
        .btn {
          background-color: rgba(8, 84, 132, 1);
          transform: scale(1.2);
        }
      }
      .intro {
        font-size: 18px;
        color: #777;
        padding-left: 30px;
      }
      .btn {
        cursor: pointer;
        margin-left: 30px;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 150px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: rgba(8, 84, 132, 0.7);
        transition: transform 0.8s linear;
      }
    }
  }
}
</style>
